import { createFetch } from "@vueuse/core";
const baseUrlFCH = process.env.VUE_APP_ENDPOINT_FUNCTIONS_FCH;
export const useFetchJSONFCH = createFetch({
  baseUrl: baseUrlFCH,
  combination: "overwrite",
  options: {
    immediate: false,
    // beforeFetch in pre-configured instance will only run when the newly spawned instance do not pass beforeFetch
    async beforeFetch({ options }) {
      options.headers = {
        ...options.headers,
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("tokenAdb2c")}`,
        "X-Referer": window.location.href,
      };

      return { options };
    },
  },
});
